import api from './api';
import { LoginCredentials, User } from '../../types/auth.types';

interface LoginResponse {
  user: User;
  access_token: string;
  refresh_token: string;
}

class AuthService {
  private readonly endpoint = '/api/v1/auth';

  async login(credentials: LoginCredentials): Promise<LoginResponse> {
    const response = await api.post<LoginResponse>(`${this.endpoint}/login`, credentials);
    return response.data;
  }

  async logout(): Promise<void> {
    try {
      await api.post(`${this.endpoint}/logout`);
    } catch (error) {
      console.error('Logout error:', error);
    }
  }

  async getCurrentUser(): Promise<{ success: boolean; data: User }> {
    const response = await api.get<{ success: boolean; data: User }>(`${this.endpoint}/profile`);
    return response.data;
  }

  async refreshToken(refreshToken: string): Promise<{ access_token: string; refresh_token: string }> {
    const response = await api.post<{ access_token: string; refresh_token: string }>(
      `${this.endpoint}/refresh`,
      { refreshToken }
    );
    return response.data;
  }
}

export const authService = new AuthService();